import { List } from "@medplum/fhirtypes";

import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const eduFoldersAdapter = createEntityAdapter({
  selectId: (eduFolder: List) => eduFolder.id!,
});

const reducers = {
  loadEduFolders: eduFoldersAdapter.setAll,
};

export const eduFoldersSlice = createSlice({
  name: "eduFolders",
  initialState: eduFoldersAdapter.getInitialState(),
  reducers,
});

export const { loadEduFolders } = eduFoldersSlice.actions;

export const selectEduFolders = (state: RootState) => state.eduFolders.entities;

export const selectEduFoldersList = (state: RootState): List[] =>
  Object.values(state.eduFolders.entities);

export default eduFoldersSlice.reducer;
